import { useTranslation } from "react-i18next";
import Title from "components/Title/Title";
import FaqImage from "assets/faq-image.png";
import "./i18n";
import "./faq.scss";
import { HELP_EMAIL } from "utils/constants";
import FaqTab from "./components/FaqTab/FaqTab";

const FaqSection = () => {
  const { t } = useTranslation();

  return (
    <div className="faq-section-container faq-section-wrapper">
      <div className="faq-section-container-row">
        <div className="faq-section-container-col-xs-12 faq-section-container-col-sm-8 faq-section-container-col-12 faq-introduction">
          <h4 className="doubts-title">{t("faq:doubts")}</h4>
          <p className="channels">
            {t("faq:channels1")} <b className="faq-phone">{HELP_EMAIL}</b>
          </p>
        </div>
        <div className="faq-section-container-col-xs-12 faq-section-container-col-sm-4 faq-section-container-col-12 faq-image-container">
          <img className="faq-image" src={FaqImage} alt="faq" />
        </div>
      </div>
      <div className="faq-section-container-row" id="faq-section">
        <div className="faq-container faq-section-container-col-xs-12 faq-section-container-col-sm-10 faq-section-container-col-offset-sm-1 faq-section-container-col-12">
          <Title title={t("faq:title")} color="light-blue" />
          <div className="questions-container">
            <FaqTab tab="faq" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqSection;
